export const DEFAULT_LAYOUT_CONFIG = {
  toolbar: {
    display: false,
  },
  sidebar: {
    isOpen: false,
    isResponsive: false,
  },
};
